import { Point } from "../../../engine/space/bounds";
import { BasicMap } from "../BasicMap";
import { FloorTypes } from "../Map";

export const buildOpenness = (map: BasicMap) => {
  const openness = Array<number>(map.width * map.height);

  let tile, amount;
  for (let y = 0; y < map.height; y++) {
    amount = 0;
    for (let x = map.width - 1; 0 <= x; x--) {
      tile = map.tileAt(x, y);
      if (tile?.type === FloorTypes.EMPTY) {
        amount += 1;
        openness[x + y * 1000] = amount;
      } else {
        openness[x + y * 1000] = 0;
        amount = 0;
      }
    }
  }
  return openness;
};

export const placeInOpenness = (
  openness: number[],
  length: number,
  pos: Point,
  height: number,
  width: number
) => {
  //Update openness to prevent neighbor spawns
  for (let offset = -1; offset <= length; offset++) {
    if (0 < pos.x + offset || pos.x + offset < width) {
      if (0 < pos.y) {
        openness[pos.x + offset + (pos.y - 1) * 1000] = 0;
      }
      openness[pos.x + offset + pos.y * 1000] = 0;
      if (pos.y + 1 < height) {
        openness[pos.x + offset + (pos.y + 1) * 1000] = 0;
      }
    }
  }
  let amount = 0,
    aboveAmount = 0,
    belowAmount = 0;
  for (let x = width - 1; 0 <= x; x--) {
    if (0 < pos.y && openness[x + (pos.y - 1) * 1000]) {
      aboveAmount += 1;
      openness[x + (pos.y - 1) * 1000] = aboveAmount;
    } else {
      aboveAmount = 0;
    }

    if (openness[x + pos.y * 1000]) {
      amount += 1;
      openness[x + pos.y * 1000] = amount;
    } else {
      amount = 0;
    }

    if (pos.y + 1 < height && openness[x + (pos.y + 1) * 1000]) {
      belowAmount += 1;
      openness[x + (pos.y + 1) * 1000] = belowAmount;
    } else {
      belowAmount = 0;
    }
  }
};
